module.exports = __webpack_public_path__ + "img/mingdang1.323bca4f.png";